<template>
  <van-popup
    title="选择目的地"
    :lock-scroll="false"
    :close-on-click-overlay="false"
    v-model="isShow"
    style="    width: 100%;"
  >
    <div class="select-addr">
      <div class="select-box">
        <div class="status">
          <div class="left">
          </div>
          <div class="right">
            <input
              placeholder="请输入关键词"
              v-model.trim="queryKey"
              size="mini"
              class="input-with-select"
            >
          </div>
        </div>
        <div class="tab-bar">
            <!-- <div class="label">拼音首字母:</div> -->
            <div class="tabs">
                <span v-for="(item,index) in tabbar" :style="{color:selectTab == item.id?'#f19568':'',fontWeight:selectTab == item.id?'700':''}" @click="changeTab(item)" :key="index">{{item.name}}</span>
            </div>
        </div>
        <div class="tip">温馨提示：您最多可选择5个国家或地区！</div>
        <div class="area-content">
            <van-checkbox-group :max="5" v-model="addrArr">
                <van-checkbox icon-size="0.12rem" size="12px" :name="item" v-for="(item,index) in selectOptions" :key="index">{{item}}</van-checkbox>
            </van-checkbox-group>
        </div>
        <div class="checkShow">
          <div class="label">
            我选择的是:
            <van-tag
              v-for="(item, index) in addrArr"
              :key="index"
              @close="delDestnation(item)" 
              closable
              size="medium" 
              type="primary"
              style="margin-right: 5px;font-size:0.1rem;margin-bottom:5px"
              >{{ item }} <van-icon @click="delDestnation(item)" name="cross" /> </van-tag
            >
          </div>
        </div>
      </div>
      <div class="dialog-footer" style="text-align: right;margin-top:15px">
        <van-button size="small" @click="isShow = false">取 消</van-button>
        <van-button
          size="small"
          type="primary"
          @click="confirm()"
          style="background: #00a971; border-color: #00a971;margin-left:15px"
          >确 定</van-button
        >
      </div>
    </div>
  </van-popup>
</template>

<script>
import loadPinYinInit from './ChineseHelper.js'
import {
  Step,
  Steps,
  Popup,
  Picker,
  Field,
  Toast,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Collapse,
  CollapseItem,
  Icon,
  Dialog,
  Form,
  RadioGroup,
  Radio,
  Tab,
  Tabs,
  Button,
  Cell,
  Tag
} from "vant";
export default {
  props: ["value",'needSelect'],
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Field.name]: Field,
    [Toast.name]: Toast,
    // [Calendar.name]:Calendar,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Cell.name]:Cell,
    [Tag.name]:Tag
    // Calendar
  },
  data() {
    return {
      isShow: false,
      selectOptions:[],
      tabbar:[
          {
              id:'',
              name:'全部'
          },
          {
              id:'ABC',
              name:'ABC'
          },
          {
              id:'DEF',
              name:'DEF'
          },
          {
              id:'GHI',
              name:'GHI'
          },
          {
              id:'JKL',
              name:'JKL'
          },
          {
              id:'MNO',
              name:'MNO'
          },
          {
              id:'PQR',
              name:'PQR'
          },
          {
              id:'STU',
              name:'STU'
          },
          {
              id:'VWX',
              name:'VWX'
          },
          {
              id:'YZ',
              name:'YZ'
          }
      ],
      addrArr: [],
      selectTab:'',
      queryKey: "",
    };
  },
  watch: {
    isShow:function(val) {
      console.log('isshow',val)
      console.log('value',this.value)
      if (val) {
        try {
          this.addrArr = this.value;
          this.selectTab = ''
          this.selectOptions = this.needSelect
          console.log(this.addrArr)
        } catch (error) {}
      } else {
        this.addrArr = [];
      }
    },
    queryKey:function(val){
      this.searchFn(val)
    }
  },
  methods: {
    setFn(val) {
      this.$emit("update:value", val);
    },
    changeTab(val){
        this.selectTab = val.id
        if(!val.id){
            this.selectOptions = this.needSelect
            return
        }
        let needData = []
        this.needSelect.forEach(item=>{
            let code = loadPinYinInit.ConvertPinyin(item).substr(0,1)
            let tabArr = val.id.split('')
            tabArr.forEach(el=>{
                if(el == code){
                    needData.push(item)
                }
            })
        })
        this.selectOptions = needData
    },
    delDestnation(val){
      console.log(val)
      this.addrArr.splice(this.addrArr.indexOf(val), 1);
    },
    searchFn(val) {
        if(!val){
            this.selectOptions = this.needSelect
            return
        }
        let needData = []
        this.needSelect.forEach(item=>{
            if(item.indexOf(val) != -1){
                needData.push(item)
            }
        })
        this.selectOptions = needData
    },
    confirm(){
      console.log('this.addrArr',this.addrArr)
        this.setFn(this.addrArr)
        this.isShow = false
    }
  },
};
</script>

<style lang="scss" scoped>
.select-addr {
  font-size: 0.1rem;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  .select-box {
    .status {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
    .tab-bar{
        display: flex;
        height: 30px;
        align-items: center;
        border-bottom: 1px solid #eee;
        margin-top:10px;
        .label{
            font-size: 14px;
            font-weight:600
        }  
        .tabs{
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            flex: 1;
            flex-wrap: wrap;
            span{
                cursor: pointer;
                font-weight:600
            }
        }
    }
    .tip{
      font-size: 0.1rem;
    }
    .area-content {
      height: 300px;
      overflow: auto;
      padding: 15px 0;
      overflow-x: hidden;
      .van-checkbox-group{
          display: flex;
          flex-wrap: wrap;
          .van-checkbox{
              margin-right:0;
              width: 25%;
              margin-bottom: 10px;
              overflow: hidden;
          }
      }
    }
    .checkShow{
      padding-top: 10px;
      border-top: 1px dashed #999
    }
  }
}
</style>

<style lang="scss">
.select-addr{
  .van-checkbox__label{
    font-size: 0.1rem;
    line-height: 0.1rem;
  }
}

</style>